import { AuthenticationService } from '@/services/authentication.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ConnectorCode, ConnectorConfig, ConnectorsService, UserSession } from '@eemo/api-client';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PropertyDocExportDialogComponent } from '../property-doc-export-dialog/property-doc-export-dialog.component';

import { NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
import { InputComponent } from '../ui-forms/input/input.component';

export class ConnectorConfigDialogData {
  connectorCode: ConnectorCode;
}

@Component({
    selector: 'app-connector-config-dialog',
    templateUrl: './connector-config-dialog.component.html',
    styleUrls: ['./connector-config-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, FormsModule, ReactiveFormsModule, TranslateModule, InputComponent]
})
export class ConnectorConfigDialogComponent implements OnInit, OnDestroy {
  dialogTitle = 'connectorConfigDialog.title';
  isLoading = false;
  getConfigSub = new Subscription();
  updateConfigSub = new Subscription();

  currentUser: UserSession;

  config: ConnectorConfig;

  get form_clientId() {
    return this.form.get('clientId') as FormControl<string>;
  }
  get form_token() {
    return this.form.get('token') as FormControl<string>;
  }

  form = this.fb.group({
    clientId: [null, Validators.required],
    token: [null, Validators.required]
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConnectorConfigDialogData,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<PropertyDocExportDialogComponent>,
    private connectorService: ConnectorsService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getConnectorConfig();
  }

  ngOnDestroy(): void {
    this.getConfigSub.unsubscribe();
    this.updateConfigSub.unsubscribe();
  }

  onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.update();
    }
  }

  afterGetConfig(config: ConnectorConfig) {
    this.config = config;
    if (this.config) {
      this.form_clientId.setValue(this.config.clientId);
      this.form_token.setValue(this.config.token);
    }
  }

  update() {
    this.isLoading = true;
    const body = this.getUpdateBody();
    this.updateConfigSub = this.connectorService
      .updateConnectorUserConfig(this.currentUser.userId, this.data.connectorCode, body)
      .subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  getUpdateBody(): ConnectorConfig {
    return { ...this.form.value };
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  // ---------------------------------------- //
  //                   APIS                   //
  // ---------------------------------------- //
  getConnectorConfig() {
    this.isLoading = true;
    this.getConfigSub = this.connectorService
      .getConnectorUserConfig(this.currentUser.userId, this.data.connectorCode)
      .subscribe({
        next: (currentConfig: ConnectorConfig) => {
          this.isLoading = false;
          this.afterGetConfig(currentConfig);
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }
}
